// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:pox3Gq */\n.m_Eq8{grid-row-gap:var(--audio-spacing-16);display:grid;grid-template-columns:1fr;row-gap:var(--audio-spacing-16)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"group": "m_Eq8"
};
export default ___CSS_LOADER_EXPORT___;
